import { useDeleteManagementKey } from '@api/managementKeys';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';
import { IRowActionDialogProps } from 'types/common';
import { AccessKeyDeleteDialog } from '../../AccessKeys/index';

const DeleteDialog: React.FC<IRowActionDialogProps> = (props) => {
	const mutation = useDeleteManagementKey();
	return (
		<AccessKeyDeleteDialog
			{...props}
			mutation={mutation}
			accessKeyType={AccessKeyType.management}
		/>
	);
};

export default DeleteDialog;
